import {SupportedLocales} from '#types/locale.js';

export const sourceCostsLanguage = {
  [SupportedLocales.EN]: {
    title: 'Source Costs',
    description:
      'Understand the compute costs generated in your data warehouse.',
    sourceConnection: 'Source connection',
    demoSource: 'Demo warehouse',
    startDate: 'Start date',
    endDate: 'End date',
    jobType: 'Job type',
    allJobTypes: 'All job types',
    addJobType: 'Add job types',
    searchJobTypes: 'Search job types',
    noMatches: 'No matches found',
    showTotal: 'Show total',
    compute: 'Compute',
    computeCosts: 'Compute costs',
    totalCompute: 'Total compute cost',
    costByJobType: 'Cost by job type',
    computeGranularity: 'Compute costs granularity',
    day: 'Day',
    month: 'Month',
    quarter: 'Quarter',
    quarterBucket: (quarter: number, year: number) => `Q${quarter} ${year}`,
    jobTypeComparisonHelp:
      'Select job types in the left chart or dropdown to compare their costs over time. Colors match across both charts.',
    costlyTables: 'Costly tables',
    costlyAudiences: 'Costly audiences',
    entity: 'Entity',
    totalCost: 'Total cost',
    queryCount: 'Query count',
    costPerQuery: 'Cost per query',
    noData: 'No billing data was found for these filters.',
    unavailable: 'The cost report is unavailable.',
    unsupported:
      'Source Costs currently supports BigQuery and Snowflake connections.',
    loading: 'Loading source costs…',
  },
  [SupportedLocales.ES]: {
    title: 'Costos de fuente',
    description:
      'Comprenda los costos de cómputo generados en su almacén de datos.',
    sourceConnection: 'Conexión de fuente',
    demoSource: 'Almacén de demostración',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de finalización',
    jobType: 'Tipo de trabajo',
    allJobTypes: 'Todos los tipos de trabajo',
    addJobType: 'Agregar tipos de trabajo',
    searchJobTypes: 'Buscar tipos de trabajo',
    noMatches: 'No se encontraron coincidencias',
    showTotal: 'Mostrar total',
    compute: 'Cómputo',
    computeCosts: 'Costos de cómputo',
    totalCompute: 'Costo total de cómputo',
    costByJobType: 'Costo por tipo de trabajo',
    computeGranularity: 'Granularidad de costos de cómputo',
    day: 'Día',
    month: 'Mes',
    quarter: 'Trimestre',
    quarterBucket: (quarter: number, year: number) => `T${quarter} ${year}`,
    jobTypeComparisonHelp:
      'Seleccione tipos de trabajo en el gráfico de la izquierda o en el menú desplegable para comparar sus costos a lo largo del tiempo. Los colores coinciden en ambos gráficos.',
    costlyTables: 'Tablas costosas',
    costlyAudiences: 'Audiencias costosas',
    entity: 'Entidad',
    totalCost: 'Costo total',
    queryCount: 'Cantidad de consultas',
    costPerQuery: 'Costo por consulta',
    noData: 'No se encontraron datos de facturación para estos filtros.',
    unavailable: 'El informe de costos no está disponible.',
    unsupported:
      'Costos de fuente actualmente admite conexiones de BigQuery y Snowflake.',
    loading: 'Cargando costos de fuente…',
  },
};
